module.exports = __webpack_public_path__ + "img/li.535b82bf.svg";